export var GRPC_HOSTNAME = 'studio.inworld.ai';
export var CLIENT_ID = 'web';
export var DEFAULT_USER_NAME = 'User';
